import React from "react";
import _ from "lodash";

import { useI18n } from "Hooks";
import ProfileCascade from "UIComponents/ProfileCascade";
import { connect } from "react-redux";
import {
  getDefaultNameSortPreference,
  getDefaultStudentNameOrderPreference,
  getUserType,
} from "modules/CommonSelectors";
import {
  getSubText,
  getFormattedNameForUserType,
} from "MessagingV2/modules/Utils";
import classNames from "classnames";
import classes from "./RecipientsList.scss";

const getAvatarStyles = () => {
  return {
    size: "medium",
    randomizeColor: true,
    shade: "light",
    shape: "square",
  };
};
const profileCascadeContainerStyle = { flexShrink: "0" };

const RecipientsList = props => {
  const {
    users,
    defaultNameSortPreference,
    loggedInUserType,
    defaultStudentNameOrderPreference,
  } = props;
  const { t } = useI18n(["common", "announcement"]);

  return (
    <div className={classes.container}>
      {_.map(users, user => {
        const fullName = getFormattedNameForUserType({
          user,
          orderBy: defaultNameSortPreference,
          defaultStudentNameOrderPreference,
          isFormattedNameV2: true,
        });

        const avatarItem = {
          id: _.get(user, "id"),
          value: fullName,
          imageUrl: _.get(user, "profileImage"),
        };

        const subtitle = getSubText({
          loggedInUserRole: loggedInUserType,
          messagedUserObj: user,
          messagedUserRole: _.get(user, "type"),
          t,
        });

        return (
          <div className={classes.userInfoContainer} key={_.get(user, "id")}>
            <div className={classes.userInfo}>
              <ProfileCascade
                items={[avatarItem]}
                showAvatar
                dsVersion="2.0"
                avatarStyles={getAvatarStyles()}
                mainContainerStyle={profileCascadeContainerStyle}
              />
              <div className={classes.basicUserDetails}>
                <div className={classNames("text-body", classes.textEllipsis)}>
                  {fullName}
                </div>
                {subtitle ? (
                  <div
                    className={classNames(
                      "text-body-s",
                      "text-textSubtle",
                      classes.textEllipsis
                    )}
                  >
                    {subtitle}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const mapStateToProps = state => {
  const loggedInUserType = getUserType(state);
  return {
    defaultNameSortPreference: getDefaultNameSortPreference(state),
    defaultStudentNameOrderPreference: getDefaultStudentNameOrderPreference(
      state
    ),
    loggedInUserType,
  };
};

export default connect(mapStateToProps)(RecipientsList);
